import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { panelStyles as styles } from './styles';

export interface FilterDrawerPanelProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  onClearAll: () => void;
  title?: string;
  children: React.ReactNode;
}

const FilterDrawerPanel: React.FC<FilterDrawerPanelProps> = ({
  isOpen,
  onClose,
  onSave,
  onClearAll,
  title = 'Filters',
  children,
}) => {
  return (
    <Drawer
      open={isOpen}
      anchor="right"
      onClose={onClose}
      data-testid="filter-drawer-panel"
      sx={styles.drawerPaper}
      // Keep the drawer's DOM mounted across open/close transitions so the
      // filter children inside continue to register their activity with the
      // FilterActivityContext registry even when the drawer is hidden.
      // Without this, closing the drawer would unmount each filter, cleanup
      // would set their reported activity to `false`, and the badge would
      // drop to zero on mobile.
      ModalProps={{ keepMounted: true }}
    >
      <Box sx={styles.drawerInner}>
        <Box sx={styles.header}>
          <Typography variant="h6" component="div" sx={styles.title}>
            {title}
          </Typography>
          <IconButton
            onClick={onClose}
            aria-label="Close filters"
            data-testid="filter-drawer-close"
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={styles.body}>
          {children}
          {/* Right below the filters, so the actions stay next to what they
              apply to instead of at the foot of a tall screen. Cancel sits
              on its own on the left; Clear all and Save share the right. */}
          <Box sx={styles.actions}>
            <Button
              onClick={onClose}
              color="secondary"
              variant="contained"
              data-testid="filter-drawer-cancel"
            >
              Cancel
            </Button>
            <Box sx={styles.trailingActions}>
              <Button
                onClick={onClearAll}
                color="secondary"
                variant="contained"
                data-testid="filter-drawer-clear-all"
              >
                Clear all
              </Button>
              <Button
                onClick={onSave}
                color="primary"
                variant="contained"
                data-testid="filter-drawer-save"
              >
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default FilterDrawerPanel;
